import { render } from "./continue-to-manage-signatories.html?vue&type=template&id=3b2f524c&scoped=true&ts=true&external"
import script from "./continue-to-manage-signatories.ts?vue&type=script&lang=ts&external"
export * from "./continue-to-manage-signatories.ts?vue&type=script&lang=ts&external"

import "./continue-to-manage-signatories.scss?vue&type=style&index=0&id=3b2f524c&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2f524c"]])

export default __exports__